module.exports = __webpack_public_path__ + "assets/search.7d9e3dd0.svg";